import { Pad, PadBox } from 'component/basics';
import { CTAButton } from 'component/button';
import { colorTextSecondary } from 'component/color';
import { Modal } from 'component/modal';
import { Heading, UtilityText } from 'component/text';
import { t } from 'util/stdtypes';

export function BlockConfirmationModal({ onBlock, onClose }) {
    return (
        <Modal onClose={onClose}>
            <PadBox horiz={20} vert={40}>
                <Heading label={t('Block this user?')} type='large' />
                <Pad size={8} />
                <UtilityText
                    color={colorTextSecondary}
                    label={t('Do you really want to block this user? You can unblock the user via the profile page.')}
                />
                <Pad size={32} />
                <CTAButton
                    label={t('Block user')}
                    onPress={async () => {
                        onBlock();
                    }}
                    type='delete'
                    wide
                />
            </PadBox>
        </Modal>
    );
}

export function UnblockConfirmationModal({ onUnblock, onClose }) {
    return (
        <Modal onClose={onClose}>
            <PadBox horiz={20} vert={40}>
                <Heading label={t('Unblock this user?')} type='large' />
                <Pad size={8} />
                <UtilityText color={colorTextSecondary} label={t('Do you really want to unblock this user?')} />
                <Pad size={32} />
                <CTAButton
                    label={t('Unblock user')}
                    onPress={async () => {
                        onUnblock();
                    }}
                    type='delete'
                    wide
                />
            </PadBox>
        </Modal>
    );
}
